// ----------------------------------------------------------------------------
// Section: Site Header
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import $ from 'jquery';
import '../../snippets/announcement-bar/announcement-bar';
import '../../snippets/menu/menu';
import '../../snippets/country-switcher/country-switcher';
import '../../snippets/mini-cart/mini-cart'; // TODO: include mini cart here for now.
import '../../snippets/search-form/search';
import '../../snippets/icon/icon';
import '../../snippets/smart-cart-template/smart-cart-template';

// Styles
import './_header.scss';

// Optional Features
//import './header--sticky';


// -------------------------------------
// Variables
// -------------------------------------

var headerClass = '.header';
var menuClass   = '.menu--default';
var openMenuBtn  = '.js-openMenu';
var closeMenuBtn  = '.js-closeMenu';


// -------------------------------------
// Hooks
// -------------------------------------
$(document).ready(function() {
    const closeMenu = () => {
        $(openMenuBtn).attr('aria-expanded', 'false');
        $(openMenuBtn).removeClass('hidden');
        $(openMenuBtn).trigger('focus');
        $(closeMenuBtn).addClass('hidden');
        $(headerClass).removeClass('js--isOpen');
        $(menuClass).removeClass('js--isOpen');
        $('body').removeClass('noscroll');
    };

    function closeMenus() {
        // close menu
        document.querySelectorAll('.header .menu__item--dropdown.js--isOpen').forEach(item => {
            item.classList.remove('js--isOpen');
            item.querySelector('.menu__link').setAttribute('aria-expanded', 'false');
        });
    }

    // Unless we click inside the header,
    // we probably don't want to have open navs
    $('body').on('click', function(event) {
        if (!$(event.target).closest(menuClass).length && !$(event.target).closest('.header__container').length && $(event.target).closest('.header').hasClass('js--isOpen')) {
            closeMenu();
        }
    });

    // Open menu on mobile
    $(openMenuBtn).on('click', function(event) {
        event.preventDefault();
        $(openMenuBtn).attr('aria-expanded', 'true');
        $(openMenuBtn).addClass('hidden');
        $(closeMenuBtn).removeClass('hidden');
        $(closeMenuBtn).trigger('focus');
        $(headerClass).addClass('js--isOpen');
        $(menuClass).addClass('js--isOpen');
        $('body').addClass('noscroll');
    });

    // Close menu on mobile
    $(closeMenuBtn).on('click', function(event) {
        event.preventDefault();
        closeMenu();
    });

    document.addEventListener('keyup', function(e) {
        // Listens for Escape Key
        if (e.key == 'Escape' && $(menuClass).hasClass('js--isOpen') ) {
            closeMenu();
        } else if (e.key === 'Escape') {
            closeMenus();
        }
    });

});
